module.exports = __webpack_public_path__ + "static/img/E.47cc620.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl/E.png
// module id = ebq/
// module chunks = 0